const startOfDay = value => {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const notificationGroup = (value, now) => {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '更早';
  const today = startOfDay(now);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const week = new Date(today);
  week.setDate(week.getDate() - (week.getDay() + 6) % 7);
  if (date >= today) return '今天';
  if (date >= yesterday) return '昨天';
  if (date >= week) return '本周';
  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth()) return '本月';
  return `${date.getFullYear()}年${date.getMonth() + 1}月`;
};

export const notificationTime = (value, now) => {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  const seconds = Math.max(0, (now - date.getTime()) / 1000);
  if (seconds < 60) return '刚刚';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}分钟前`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}小时前`;
  if (seconds < 30 * 86400) return `${Math.floor(seconds / 86400)}天前`;
  return date.toLocaleDateString('zh-CN');
};
